import React, { useState } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  FormControlLabel,
} from '@mui/material'
import TenantTopbar from '@/components/layout/TenantTopbar'

export const TopbarSection = () => {
  const [tenant, setTenant] = useState('suncoast')
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <FormControl size='small' sx={{ minWidth: 220 }}>
          <InputLabel id='tenant-label'>Tenant</InputLabel>
          <Select
            labelId='tenant-label'
            label='Tenant'
            value={tenant}
            onChange={e => setTenant(e.target.value)}
          >
            <MenuItem value='suncoast'>Suncoast</MenuItem>
            <MenuItem value='ozark'>Ozark</MenuItem>
            <MenuItem value='rrvbc'>RRVBC</MenuItem>
          </Select>
        </FormControl>
        <FormControlLabel
          control={
            <Switch
              checked={isAuthenticated}
              onChange={e => setIsAuthenticated(e.target.checked)}
            />
          }
          label='Authenticated'
        />
      </Box>
      <TenantTopbar tenant={tenant} isAuthenticated={isAuthenticated} />
    </Box>
  )
}
